import React, { useState } from 'react';
import './AccountCategoryForm.css';
import '../../../shared/StyledInput.css';
import RequiredMark from '../../../shared/RequiredMark';
import CancelButton from '../../../shared/CancelButton';
import SaveButton from '../../../shared/SaveButton';

function AccountCategoryForm({ initial, onSave, onCancel, loading }) {
  const [category_code, setCategoryCode] = useState(initial?.category_code || '');
  const [category_name, setCategoryName] = useState(initial?.category_name || '');
  const [normal_balance, setNormalBalance] = useState(initial?.normal_balance || 'debit');
  const [sort_order, setSortOrder] = useState(initial?.sort_order || 100);
  const [system_locked, setSystemLocked] = useState(initial?.system_locked ?? false);
  const [description, setDescription] = useState(initial?.description || '');
  const [error, setError] = useState('');

  const validate = () => {
    if (!category_code.trim()) return 'Category code is required.';
    if (!/^[a-z0-9_]{2,20}$/.test(category_code.trim())) return 'Category code must be 2-20 lowercase letters, numbers or underscores.';
    if (!category_name.trim()) return 'Category name is required.';
    if (!['debit', 'credit'].includes(normal_balance)) return 'Normal balance must be debit or credit.';
    if (!String(sort_order).match(/^\d+$/) || Number(sort_order) < 1) return 'Sort order must be a positive number.';
    return '';
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const err = validate();
    if (err) return setError(err);
    setError('');
    onSave({
      category_code: category_code.trim().toLowerCase(),
      category_name: category_name.trim().replace(/\s+/g, ' '),
      normal_balance,
      sort_order: Number(sort_order),
      system_locked,
      description: description.trim(),
    });
  };

  return (
    <form className="account-category-form" onSubmit={handleSubmit} style={{ minWidth: 320 }}>
      <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
        <div>
          <label>Category Code<RequiredMark /></label><br />
          <input
            className="styled-input"
            value={category_code}
            onChange={(e) => setCategoryCode(e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, '').slice(0, 20))}
            maxLength={20}
            placeholder="e.g., asset"
          />
        </div>
        <div>
          <label>Category Name<RequiredMark /></label><br />
          <input
            className="styled-input"
            value={category_name}
            onChange={(e) => setCategoryName(e.target.value)}
            maxLength={100}
            placeholder="e.g., Asset"
          />
        </div>
      </div>

      <div style={{ display: 'flex', gap: 14, marginTop: 10, flexWrap: 'wrap' }}>
        <div>
          <label>Normal Balance<RequiredMark /></label><br />
          <select className="styled-input" value={normal_balance} onChange={(e) => setNormalBalance(e.target.value)}>
            <option value="debit">Debit</option>
            <option value="credit">Credit</option>
          </select>
        </div>
        <div>
          <label>Sort Order<RequiredMark /></label><br />
          <input
            className="styled-input"
            type="number"
            min="1"
            value={sort_order}
            onChange={(e) => setSortOrder(e.target.value)}
            style={{ width: 90 }}
          />
        </div>
      </div>

      <div style={{ display: 'flex', gap: 16, marginTop: 10 }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <input type="checkbox" checked={system_locked} onChange={(e) => setSystemLocked(e.target.checked)} />
          System Locked
        </label>
      </div>

      <div style={{ marginTop: 10 }}>
        <label>Description</label><br />
        <textarea
          className="styled-input"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={3}
          style={{ width: '100%', resize: 'vertical' }}
          placeholder="Optional notes"
        />
      </div>

      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}

      <div style={{ marginTop: 12 }}>
        <SaveButton loading={loading} />
        <CancelButton onClick={onCancel} disabled={loading} style={{ marginLeft: 8 }} />
      </div>
    </form>
  );
}

export default AccountCategoryForm;
